import { api } from "@/lib/api";

export const uploadAadhaarPhoto = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/masters/employee-kyc/photo", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
};
export const fetchAadhaarPhoto = async (path) => {
  const { data } = await api.get("/masters/employee-kyc/photo", { params: { path }, responseType: "blob" });
  return URL.createObjectURL(data);
};
export const listKycRequests = async () => (await api.get("/masters/kyc-requests")).data;
export const approveKycRequest = async (id) => (await api.post(`/masters/kyc-requests/${id}/approve`)).data;
export const rejectKycRequest = async (id, note = "") => (await api.post(`/masters/kyc-requests/${id}/reject`, { note })).data;
export const exportEmployeesXlsx = async () => {
  const { data } = await api.get("/masters/employees/export.xlsx", { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "employees.xlsx";
  a.click();
  URL.revokeObjectURL(url);
};
export const importEmployeesXlsx = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/masters/employees/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
};
